import axiosInstance from "@/api/axios-instance";

export type IncorrectMappingViolationReason =
  | "no_compatible_bundle"
  | "out_of_range";

export interface IncorrectMappedSession {
  id: string;
  name: string;
  start_time: string;
  status: string;
  violation_reason: IncorrectMappingViolationReason;
}

export interface IncorrectMappedSessionsResponse {
  sessions: IncorrectMappedSession[];
}

export async function getIncorrectMappedSessions(
  bundleUsageId: string
): Promise<IncorrectMappedSessionsResponse> {
  const response = await axiosInstance.get(
    `/audit/incorrect-mapped-sessions/${bundleUsageId}`
  );
  return response.data;
}
